module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "basic-box cabinet__basic-box"
  }, [_c('div', {
    staticClass: "basic-box__title"
  }, [_vm._v("Ближайшие события")]), _vm._v(" "), _vm._l((_vm.value), function(event) {
    return _c('visit-item', {
      key: event._id,
      attrs: {
        "event": event
      }
    })
  }), _vm._v(" "), (!_vm.value.length) ? _c('div', [_vm._v("У Вас еще нет событий")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value.length == 5),
      expression: "value.length == 5"
    }],
    staticClass: "basic-box__btns text_center"
  }, [_c('button', {
    staticClass: "basic-box__btn btn_light-blue",
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v("\n\t\t\t\tПоказать больше\n\t\t\t\t"), _c('i', {
    staticClass: "basic-box__icon_light basic-box__icon_arrow_down icon ion-chevron-down"
  })])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c95a7b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComingVisit.vue
// module id = 591
// module chunks = 0